<template>
  <div>
    <!-- 导航栏，非全屏模式显示 -->
    <van-nav-bar v-if="!isFullscreen" style="position: fixed; top: 0; left: 0; width: 100%; background: url(/img/counter/top-bg.webp) no-repeat rgb(8, 76, 203);" :title="gameName" left-arrow @click-left="$router.back()">
      <template #right>
        <div @click="toggleFullscreen" style="color: white; margin-right: 15px; font-size: 16px; cursor: pointer;">
          {{ $t('quanping') || '全屏' }}
        </div>
      </template>
    </van-nav-bar>
    <div v-if="!isFullscreen" style="height: 46px"></div>
    
    <!-- 全屏模式下的退出按钮 -->
    <div v-if="isFullscreen" class="fullscreen-exit-btn" @click="toggleFullscreen">
      <span class="exit-arrow">↑</span>
    </div>
    
    <!-- 游戏内容 -->
    <div v-if="url" :style="isFullscreen ? 'height: 100vh; overflow: hidden;' : 'height: calc(100vh - 46px); overflow-y: scroll; -webkit-overflow-scrolling: touch'">
      <iframe style="height: 100%; width: 100%" ref="iframe" scrolling="auto" frameborder="0" id="iframe"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
      gameName: '',
      isFullscreen: false,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    
    console.log('GamePage query parameters:', query);
    
    // 打开代理
    if (query.dailiD == 1) {
      that.getAgentLoginUrl();
      return;
    }
    // 打开客服
    if (query.dailiD == 2) {
      that.getservicerurl();
      return;
    }
    if (query.app == 1) {
      that.url = that.$store.state.appInfo.ios_download_url;
      return;
    }
    if (query.name) {
      // 直接使用传入的游戏名称
      that.gameName = query.game_name || query.name;
      console.log('Final game name set to:', that.gameName);
      that.goGamePage(query.name, query.type, query.code);
    }
  },
  methods: {
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开代理
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
// 打开游戏
goGamePage(name, type, code) {
  let that = this;
  
  // 获取当前语言对应的货币代码（两位代码）
  const currencyMap = {
    'zh': 'CN',
    'tw': 'TW',
    'en': 'EN',
    'th': 'TH',
    'vi': 'VI',
    'jp': 'JP',
    'kr': 'KR',
    'pt': 'BR',
    'kh': 'KH',
    'id': 'ID'
  };
  const userLang = localStorage.getItem('language') || 'zh';
  const currency = currencyMap[userLang] || 'CN';
  
  that.$apiFun
    .post('/api/getGameUrl', { 
      plat_name: name, 
      game_type: type || 0, 
      game_code: code, 
      is_mobile_url: 1,
      currency: currency,      // 货币参数
      lang: userLang           // ← 添加这一行：传递语言参数
    })
    .then(res => {
      console.log(res);
      if (res.code != 200) {
        that.$parent.showTost(0, res.message);
      }
      if (res.code == 200) {
        that.url = res.data.url;
        if (res.data.game_name) {
          that.gameName = res.data.game_name;
        }
      }
    })
    .catch(res => {});
},
    // 切换全屏
    toggleFullscreen() {
      let that = this;
      if (!that.isFullscreen) {
        // 进入全屏
        let elem = document.documentElement;
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
        that.isFullscreen = true;
      } else {
        // 退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        that.isFullscreen = false;
      }
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
    if (that.$refs.iframe && that.url) {
      that.$refs.iframe.contentWindow.location.replace(that.url);
    }
  },
};
</script>

<style lang="scss" scoped>
.van-nav-bar__arrow {
  color: white !important;
}

.van-icon-arrow-left {
  color: white !important;
}

.van-nav-bar__title {
  color: white !important;
}
</style>

<style>
/* 全局样式，确保导航栏返回箭头和标题为白色 */
.van-nav-bar__arrow {
  color: white !important;
}

.van-icon-arrow-left {
  color: white !important;
}

.van-nav-bar__title {
  color: white !important;
  font-weight: bold !important;
}

/* 全屏退出按钮样式 */
.fullscreen-exit-btn {
  position: fixed;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9999;
  transition: all 0.3s ease;
}

.fullscreen-exit-btn:hover {
  background-color: rgba(0, 0, 0, 0.7);
  transform: scale(1.1);
}

.exit-arrow {
  color: white;
  font-size: 20px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/mode/gamePage.vue